import { createAction, props } from '@ngrx/store';
import { Intervention } from '../../../models/intervention';
import { Device } from '../../../models/device';
import { HttpErrorResponse } from '@angular/common/http';

export const getDevice = createAction(
  '[Device] Get Device',
  props<{ intervention: Intervention; deviceUniqueId: string }>()
);

export const getDeviceSuccess = createAction('[Device] Get Device Success', props<{ device: Device }>());

export const getDeviceError = createAction('[Device] Get Device Error', props<{ err: HttpErrorResponse }>());

export const getDevices = createAction('[Device] Get Devices', props<{ intervention: Intervention }>());

export const getDevicesSuccess = createAction('[Device] Get Devices Success', props<{ devices: Device[] }>());

export const getDevicesError = createAction('[Device] Get Devices Error', props<{ err: HttpErrorResponse }>());

export const editDeviceTag = createAction(
  '[Device] Edit Device Tag',
  props<{ intervention: Intervention; device: Device }>()
);

export const editDeviceTagSuccess = createAction('[Device] Edit Device Tag Success', props<{ device: Device }>());

export const editDeviceTagError = createAction('[Device] Edit Device Tag Error', props<{ err: HttpErrorResponse }>());

export const saveUnusedDevice = createAction(
  '[Device] Save Unused Device',
  props<{ interventionId: number; device: Device }>()
);

export const saveUnusedDeviceSuccess = createAction('[Device] Save Unused Device Success', props<{ device: Device }>());

export const saveUnusedDeviceError = createAction(
  '[Device] Save Unused Device Error',
  props<{ err: HttpErrorResponse }>()
);

export const connectingMqttClientError = createAction(
  '[Device] Connecting Mqtt Client Error',
  props<{ err: string }>()
);
